module.exports = __webpack_public_path__ + "static/media/IMG_024.52324a11.JPG";